const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 512 512",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "E-mail") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M114,81a34.038,34.038,0,0,1,34-34H118A34.038,34.038,0,0,0,84,81V95h30Z",
    style: {
      fill: "#d4e1f4"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 107,
    width: 30,
    height: 286,
    style: {
      fill: "#d4e1f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114,431V405H84v26a34.038,34.038,0,0,0,34,34h30A34.038,34.038,0,0,1,114,431Z",
    style: {
      fill: "#d4e1f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.5,477h160A45.627,45.627,0,0,0,324,431V331H312v62H84V107H247.5a6,6,0,0,0,0-12H84V81c0-18.748,15.752-34,34.5-34h160C297.248,47,312,62.252,312,81V95H298.5a6,6,0,0,0,0,12H312v48h12V81a45.627,45.627,0,0,0-45.5-46h-160C93.135,35,72,55.636,72,81V431C72,456.364,93.135,477,118.5,477ZM84,405H312v26c0,18.748-14.752,34-33.5,34h-160C99.752,465,84,449.748,84,431Z",
    style: {
      fill: "#2f55d4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.2,95a6,6,0,0,0,0,12H278.31a6,6,0,0,0,0-12Z",
    style: {
      fill: "#2f55d4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.5,456a21,21,0,1,0-21-21A21.024,21.024,0,0,0,198.5,456Zm0-30a9,9,0,1,1-9,9A9.01,9.01,0,0,1,198.5,426Z",
    style: {
      fill: "#2f55d4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439,174a26,26,0,0,0-26-26H213a26,26,0,0,0-26,26V312a26,26,0,0,0,26,26H413a26,26,0,0,0,26-26ZM213.5,326a13.907,13.907,0,0,1-6.6-1.661L255.661,264.2a6,6,0,1,0-9.32-7.557l-46.9,57.535A14.225,14.225,0,0,1,199,312V193.654l93.96,73.862a29.389,29.389,0,0,0,20.417,8.178,28.668,28.668,0,0,0,20.1-8.177L427,193.663V312a14.265,14.265,0,0,1,.054,2.237l-46.938-57.611a5.924,5.924,0,0,0-8.38-.85,6,6,0,0,0-.819,8.442l49.141,60.135A13.849,13.849,0,0,1,413.5,326Zm0-166h200c7.72,0,13.5,6.28,13.5,14v4.384L325.861,258.292c-.179.141-.225.292-.386.452a17.151,17.151,0,0,1-24.134,0c-.162-.161-.551-.312-.73-.453L199,178.374V174C199,166.28,205.78,160,213.5,160Z",
    style: {
      fill: "#2eca8b"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/Email.9a6e87aa3509c26b3cacc8d046cb971a.svg";
export { ForwardRef as ReactComponent };